import React from 'react'
import { Grid } from '@hermes/web-components'
import { StyledNumber, StyledNumberDescription } from './styles'

const TrustRatingStatistic = ({ count, name }: { count?: number; name?: string }) => (
  <Grid item container alignItems="center" sm>
    <StyledNumber>{count ?? null}</StyledNumber>
    <StyledNumberDescription>{count !== undefined ? name : null}</StyledNumberDescription>
  </Grid>
)

export default TrustRatingStatistic
